import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'ui-checkbox',
  standalone: true,
  imports: [],
  templateUrl: './ui-checkbox.component.html',
  styleUrl: './ui-checkbox.component.scss'
})
export class UiCheckboxComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() ariaLabel?: string;

  /** Additional classes applied to the label wrapper */
  @Input() className = '';

  @Output() checkedChange = new EventEmitter<boolean>();

  onChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;
    this.checkedChange.emit(this.checked);
  }

  get wrapperClasses(): string {
    const classes = ['label', 'cursor-pointer', 'justify-start', 'gap-3'];
    if (this.className) {
      classes.push(this.className);
    }
    return classes.join(' ');
  }

  get inputClasses(): string {
    const classes = ['checkbox', 'checkbox-primary'];
    return classes.join(' ');
  }

  get computedAriaLabel(): string | undefined {
    return this.ariaLabel || (this.label ? this.label : undefined);
  }
}

